export type BadgeModule = string | { default: string }

export type BadgeContext = {
  keys(): Array<string>
  (id: string): BadgeModule
}

declare const require: {
  context(directory: string, useSubdirectories: boolean, regExp: RegExp): BadgeContext
}

export const appStoreBadges = require.context('./appStore', false, /\.svg$/)
export const googlePlayBadges = require.context('./googlePlay', false, /\.svg$/)
